import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isDragActive } = {}) => ({
  root: {
    backgroundColor: isDragActive ? theme.palette.lightGrey : 'initial',
    border: '2px dashed #C6CAC6',
    borderRadius: 6,
    padding: 20,
    marginBottom: 10,
    marginTop: theme.spacing(2),
    textAlign: 'center',
    width: '100%',
    outline: 'unset',
    [theme.breakpoints.down('md')]: {
      border: 'none',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        border: 'none',
        padding: theme.spacing(0.5),
        marginTop: 0,
      }),
    },
  },
}));
